var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "heading" },
              [
                _c(
                  "b-row",
                  { attrs: { "align-v": "center" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "2" } },
                      [
                        _vm.next_form_id
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "Verification",
                                    params: { id: _vm.next_form_id }
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  { attrs: { variant: "secondary" } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("FORMS.NEXT_FORM")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "8" } },
                      [
                        _c(
                          "b-row",
                          {
                            attrs: { "align-v": "center", "align-h": "center" }
                          },
                          [
                            _c("b-col", { attrs: { sm: "6" } }, [
                              _c(
                                "h3",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.d100.topleft",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: this.formData.title }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("COMMON.FORM")) +
                                      ": " +
                                      _vm._s(_vm.formData.title)
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c(
                                "div",
                                { staticClass: "paginate-page float-left" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        title: "Go to previous page",
                                        variant: "link",
                                        disabled: _vm.canGoToPrev
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.saveAndGoToPage(_vm.prevPage)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "fa fa-arrow-left"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _c("span", { staticClass: "h4" }, [
                                      _vm._v(_vm._s(_vm.getCurrentPage))
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("COMMON.OF")) +
                                        " " +
                                        _vm._s(_vm.totalPages)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      attrs: {
                                        title: "Go to next page",
                                        variant: "link",
                                        disabled: _vm.canGoToNext
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.saveAndGoToPage(_vm.nextPage)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "fa fa-arrow-right"
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "2" } },
                      [
                        _vm.prev_form_id
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "Verification",
                                    params: { id: _vm.prev_form_id }
                                  }
                                }
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: { variant: "secondary" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("FORMS.PREV_FORM")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.processedDataLoaded && _vm.formData.template_id === "-7"
        ? _c("b-card", [
            _c("div", { staticClass: "p-2" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("FORMS.PROCESSED_DATA") + ":"))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pull-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-1 mr-1",
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled:
                          _vm.updatedPEVIds.length === 0 || !_vm.checkauth
                      },
                      on: {
                        click: function($event) {
                          _vm.saveData(true)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("COMMON.SAVE")) + "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  this.docStatus !== "unmatched" &&
                  _vm.checkauth &&
                  Object.keys(this.allPageIdMap).length > 1
                    ? _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function($event) {
                              _vm.acceptFormDoc()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm.processDone) + " All ")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-1 mr-1",
                      attrs: {
                        variant: "success",
                        size: "sm",
                        disabled:
                          this.docStatus === "unmatched" && !_vm.checkauth
                      },
                      on: { click: _vm.acceptForm }
                    },
                    [
                      _c("i", { staticClass: "fa fa-check" }),
                      _vm._v(" " + _vm._s(_vm.processDone) + "\n          ")
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.tableHeaders.length > 0
              ? _c("div", { staticClass: "excel-workbook" }, [
                  _vm.formData.processed_tree_data.headers
                    ? _c("table", { staticClass: "stick-table" }, [
                        _c(
                          "thead",
                          _vm._l(_vm.tableHeaders, function(header, index) {
                            return _c("th", { key: index }, [
                              _vm._v(_vm._s(header))
                            ])
                          })
                        ),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.updatedPEVs, function(entry, pev_id) {
                            return _c(
                              "tr",
                              { key: pev_id },
                              _vm._l(_vm.tableHeaders, function(header, index) {
                                return _c("td", { key: index }, [
                                  _vm.editedPEV(pev_id, header)
                                    ? _c("span", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "table-input table-input-edited",
                                          attrs: {
                                            title:
                                              "Original Value: " +
                                              _vm.originalPEVs[pev_id][header]
                                          },
                                          domProps: { value: entry[header] },
                                          on: {
                                            change: function($event) {
                                              _vm.updateExcelData(
                                                $event,
                                                pev_id,
                                                header
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    : _c("span", [
                                        _c("input", {
                                          staticClass: "table-input",
                                          domProps: { value: entry[header] },
                                          on: {
                                            change: function($event) {
                                              _vm.updateExcelData(
                                                $event,
                                                pev_id,
                                                header
                                              )
                                            }
                                          }
                                        })
                                      ])
                                ])
                              })
                            )
                          })
                        )
                      ])
                    : _vm._e()
                ])
              : _c("div", { staticClass: "no-excel-data" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("FORMS.NO_LINE_ITEMS")) +
                      "\n      "
                  )
                ])
          ])
        : _c(
            "b-card",
            { staticClass: "p-4" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "4" } },
                    [
                      _c("b-card", { staticClass: "process-data p-2" }, [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("FORMS.PROCESSED_DATA")))
                            ]),
                            _vm._v(" "),
                            _vm.processedDataLoaded
                              ? _c(
                                  "div",
                                  { staticClass: "float-right" },
                                  [
                                    _vm.shouldShowSignInvoice && _vm.checkauth
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.showSignInvoice()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("INVOICE.SIGN")
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.shouldShowApproveInvoice &&
                                    _vm.checkauth
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.showSignInvoice()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-pencil"
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("INVOICE.APPROVE")
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hideExpandCollapse
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            attrs: {
                                              title: "Expand All Sections",
                                              size: "sm",
                                              variant: "primary"
                                            },
                                            on: { click: _vm.expandAllSections }
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass: "fa fa-expand",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hideExpandCollapse
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            attrs: {
                                              title: "Collapse All Sections",
                                              size: "sm",
                                              variant: "primary"
                                            },
                                            on: {
                                              click: _vm.collapseAllSections
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _c("i", {
                                                staticClass: "fa fa-compress",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger"
                                        },
                                        on: { click: _vm.showRejectFormModal }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-check" }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(" Reject ")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled: !this.exportFormFlag
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.exportSalesforce()
                                          }
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-check" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            " " + _vm._s(_vm.processDone) + " "
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.processValueText,
                                    expression: "processValueText"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "FORMS.SERACH_PLACEHOLDER"
                                  )
                                },
                                domProps: { value: _vm.processValueText },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.processValueText = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.processedDataLoaded && this.formData.is_ins_card
                              ? _c(
                                  "div",
                                  { staticClass: "float-right add-field-btn" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal.newField",
                                            modifiers: { newField: true }
                                          }
                                        ],
                                        attrs: {
                                          type: "submit",
                                          size: "sm",
                                          variant: "primary"
                                        }
                                      },
                                      [
                                        _c("i", { staticClass: "fa fa-plus" }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("FORMS.ADD_FIELD")
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.formData.form_doc_status === "unmatched" &&
                        !this.processData.children > 0 &&
                        _vm.showAddDataButton
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center mt-3"
                              },
                              [
                                _c(
                                  "b-button",
                                  { on: { click: _vm.manualData } },
                                  [_vm._v("Add Data Manually")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.processedDataLoaded
                          ? _c("div", { staticClass: "range-slider" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.minConf,
                                    expression: "minConf"
                                  }
                                ],
                                attrs: {
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  type: "range"
                                },
                                domProps: { value: _vm.minConf },
                                on: {
                                  change: _vm.slider,
                                  __r: function($event) {
                                    _vm.minConf = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.maxConf,
                                    expression: "maxConf"
                                  }
                                ],
                                attrs: {
                                  min: "0",
                                  max: "100",
                                  step: "1",
                                  type: "range"
                                },
                                domProps: { value: _vm.maxConf },
                                on: {
                                  change: _vm.slider,
                                  __r: function($event) {
                                    _vm.maxConf = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("FORMS.CONF_RANGE")) +
                                    " : " +
                                    _vm._s(_vm.minConf) +
                                    " - " +
                                    _vm._s(_vm.maxConf)
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "scrollable-content",
                            style: { maxHeight: this.scrollHeight + "px" },
                            on: {
                              "&scroll": function($event) {
                                _vm.handleScroll($event)
                              }
                            }
                          },
                          [
                            !_vm.processedDataLoaded
                              ? _c(
                                  "content-placeholders",
                                  [
                                    _c("content-placeholders-text", {
                                      attrs: { lines: 29 }
                                    })
                                  ],
                                  1
                                )
                              : _c("processed-data-tree", {
                                  attrs: {
                                    "min-conf": this.minConf,
                                    "max-conf": this.maxConf,
                                    processedData: this.processData,
                                    autoCorrectFlag: this.formData
                                      .template_auto_correct_flag,
                                    dataBus: this.dataBus,
                                    isInsCard: this.formData.is_ins_card,
                                    imgBase: this.imgBase,
                                    imgUrl: this.formData.image_url,
                                    dataPresent: this.dataPresent,
                                    currentPage: this.getCurrentPage,
                                    docStatus: this.docStatus
                                  }
                                })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.appMode === "service"
                          ? _c(
                              "div",
                              { attrs: { slot: "footer" }, slot: "footer" },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "col-1 m-1 pull-left service-btn",
                                        attrs: {
                                          size: "sm",
                                          variant: "secondary",
                                          disabled: _vm.canGoToPrev
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.saveAndGoToPage(_vm.prevPage)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "fa fa-angle-double-left",
                                          attrs: { title: "Prev Page" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "col-8 m-1 pull-left service-btn",
                                        attrs: {
                                          type: "submit",
                                          size: "sm",
                                          variant: "primary",
                                          disabled: !_vm.checkauth
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.validateForm(_vm.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("COMMON.VALIDATE_UPDATE")
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "col-1 m-1 pull-left service-btn",
                                        attrs: {
                                          size: "sm",
                                          variant: "secondary",
                                          disabled: _vm.canGoToNext
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.saveAndGoToPage(_vm.nextPage)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "fa fa-angle-double-right",
                                          attrs: { title: "Next Page" }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _vm.canGoToNext
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "col-6 offset-2 mt-1 service-btn",
                                            attrs: {
                                              size: "sm",
                                              variant: "secondary",
                                              title: _vm.$t("COMMON.SAVE"),
                                              disabled: !_vm.checkauth
                                            },
                                            on: { click: _vm.validateToExport }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("COMMON.SAVE"))
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                attrs: { slot: "footer", align: "center" },
                                slot: "footer"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "px-5 save-btn",
                                    attrs: {
                                      type: "submit",
                                      size: "sm",
                                      variant: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.validateForm(_vm.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("COMMON.VALIDATE_UPDATE")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { lg: "8" } },
                    [
                      !_vm.editorDataLoaded
                        ? _c(
                            "b-card",
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("COMMON.FORM")) + ":")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "content-placeholders",
                                [
                                  _c("content-placeholders-img", {
                                    staticStyle: { height: "765px" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c("b-card", { staticClass: "canvas-card mb-3" }, [
                            _c(
                              "div",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-between "
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { padding: "10px" } },
                                      [
                                        _c(
                                          "strong",
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("FORMS.AVG_CONF")) +
                                                " : "
                                            ),
                                            _c(
                                              "b-badge",
                                              {
                                                attrs: {
                                                  variant: _vm.confidenceVariant
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.avgConfidenceScore)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "strong",
                                          {
                                            staticClass: "mr-1",
                                            staticStyle: {
                                              "margin-top": "11px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("FORMS.SELECT_PAGE_NUM")
                                              ) + " "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("b-form-select", {
                                          staticClass: "page_numbers",
                                          staticStyle: { width: "75px" },
                                          attrs: {
                                            plain: true,
                                            options: _vm.dataPages
                                          },
                                          model: {
                                            value: _vm.selectedPageNum,
                                            callback: function($$v) {
                                              _vm.selectedPageNum = $$v
                                            },
                                            expression: "selectedPageNum"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "paginate-page" },
                                      [
                                        this.formData.export_error
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: "danger",
                                                  title: _vm.$t(
                                                    "FORMS.EXPORT_ERROR"
                                                  )
                                                },
                                                on: {
                                                  click: _vm.showExportError
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-exclamation-triangle",
                                                  attrs: { id: "exportError" }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function($event) {
                                                !_vm.toShowOriginalImage
                                                  ? _vm.showOriginalImage(0)
                                                  : _vm.showOriginalImage(1)
                                              }
                                            }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  !_vm.toShowOriginalImage
                                                    ? "Show Original Doc"
                                                    : "Revert Back"
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: { click: _vm.hideUnhideScreen }
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.ishideUnhideClicked
                                                    ? "Unhide"
                                                    : "Hide"
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "secondary" },
                                            on: { click: _vm.showCompareModal }
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "compare-icon",
                                              domProps: {
                                                innerHTML: _vm._s(_vm.svg.clone)
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("FORMS.COMP_IMAGES")
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.formData.template_id > 0 &&
                                        _vm.appMode === "default"
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover",
                                                    modifiers: { hover: true }
                                                  }
                                                ],
                                                attrs: {
                                                  variant: "primary",
                                                  size: "md",
                                                  title: _vm.$t(
                                                    "FORMS.MATCHING_TEMPLATE"
                                                  )
                                                },
                                                on: {
                                                  click:
                                                    _vm.redirectToMatchedTemplate
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-file-text-o",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$store.state.role == "admin"
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: { size: "md" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.showUpdateLogs(1)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover",
                                                      modifiers: { hover: true }
                                                    }
                                                  ],
                                                  staticClass: "fa fa-table",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                    title: "Show Update Logs"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isAdminRole
                              ? _c("div", { attrs: { id: "canvasShow" } })
                              : _c("div", {
                                  attrs: {
                                    oncontextmenu: "return false;",
                                    id: "canvasShow"
                                  }
                                })
                          ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.canGoToPrev
                              },
                              on: {
                                click: function($event) {
                                  _vm.saveAndGoToPage(_vm.prevPage)
                                }
                              }
                            },
                            [_vm._v("Previous")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.canGoToNext
                              },
                              on: {
                                click: function($event) {
                                  _vm.saveAndGoToPage(_vm.nextPage)
                                }
                              }
                            },
                            [_vm._v("Next")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "formUpdateLogsTable",
          attrs: { title: "Form Updates", size: "lg", centered: "" }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            this.formUpdateLogs.length && _vm.isLogsLoaded
              ? _c(
                  "div",
                  [
                    _c("b-table", {
                      attrs: {
                        bordered: "",
                        hover: "",
                        striped: "",
                        fields: _vm.updateFields,
                        items: _vm.formUpdateLogs,
                        filter: _vm.filter,
                        "filter-included-fields": _vm.filterOn
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "original",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                _vm._l(data.value, function(item) {
                                  return _c("div", [_vm._v(_vm._s(item))])
                                })
                              )
                            ]
                          }
                        },
                        {
                          key: "updated",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                _vm._l(data.value, function(item) {
                                  return _c("div", [_vm._v(_vm._s(item))])
                                })
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("b-pagination", {
                      attrs: {
                        "total-rows": _vm.totalUpdateLogs,
                        "per-page": _vm.logsPerPage,
                        align: "center"
                      },
                      on: { input: _vm.logsPagination },
                      model: {
                        value: _vm.logsCurrentPage,
                        callback: function($$v) {
                          _vm.logsCurrentPage = $$v
                        },
                        expression: "logsCurrentPage"
                      }
                    })
                  ],
                  1
                )
              : _vm.isLogsLoaded
                ? _c("div", [_vm._v("\n          No logs available\n        ")])
                : _c(
                    "div",
                    [
                      _c(
                        "content-placeholders",
                        [
                          _c("content-placeholders-img", {
                            staticStyle: { height: "765px" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                { attrs: { size: "sm" }, on: { click: _vm.closeUpdateLogs } },
                [_vm._v(" Close ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "autoCorrectModal",
          attrs: {
            title: _vm.$t("FORMS.AUTO_CORRECT"),
            "ok-title": _vm.$t("COMMON.ADD"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light",
            "no-close-on-esc": "",
            "hide-header-close": "",
            centered: "",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              _vm.saveAutoCorrectStatus()
            },
            cancel: function($event) {
              _vm.dontSaveAutoCorrectStatus()
            }
          }
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("p", { staticStyle: { color: "red" } }, [
                  _vm._v(
                    "Below selected fields data will use to auto correct for future forms "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.updatedData.length > 0
            ? _c(
                "b-row",
                { staticClass: "mb-3" },
                _vm._l(_vm.updatedData, function(data) {
                  return _c(
                    "div",
                    { key: data.id, staticStyle: { padding: "5px" } },
                    [
                      data.data_type == "text" && data.present_in_dict != true
                        ? _c("input", {
                            ref: "CheckboxClicks",
                            refInFor: true,
                            staticClass: "pull-left mt-1 mr-2",
                            attrs: { type: "checkbox", id: data.id }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      data.data_type == "text" && data.present_in_dict != true
                        ? _c(
                            "label",
                            {
                              staticClass: "pull-left",
                              attrs: { for: data.id }
                            },
                            [_vm._v(" " + _vm._s(data.key) + " ")]
                          )
                        : _vm._e()
                    ]
                  )
                })
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "fieldInvalidModal",
          attrs: {
            size: "xl",
            title: _vm.$t("FORMS.VALIDATION_HEADER"),
            "close-on-esc": "",
            "hide-header-close": "",
            "close-on-backdrop": "",
            centered: ""
          }
        },
        [
          _c(
            "b-container",
            { staticClass: "error_listing", attrs: { fluid: "" } },
            [
              _vm.combinedErrors.length > 0
                ? _c(
                    "div",
                    { staticClass: "mb-3 error_listing" },
                    [
                      _c("h5", { staticClass: "error_listing" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("FORMS.SERVICE_VALIDATION") + ":")
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.combinedErrors, function(error, index) {
                        return _c(
                          "p",
                          { key: error["key"], staticClass: "error_listing" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(error["reason"]) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.requiredFieldsError && _vm.requiredFieldsError.length > 0
                ? _c(
                    "div",
                    { staticClass: "mb-3 error_listing" },
                    [
                      _c("h5", { staticClass: "error_listing" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("FORMS.REQUIRED_FIELDS_VALIDATION") + ":"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.requiredFieldsError, function(error, index) {
                        return _c(
                          "p",
                          { key: error["key"], staticClass: "error_listing" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(error["reason"]) +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.validateUpdateErrorMessages &&
              _vm.validateUpdateErrorMessages.length > 0
                ? _c(
                    "div",
                    { staticClass: "mb-3 error_listing" },
                    [
                      _c("h5", { staticClass: "error_listing" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("FORMS.VALIDATION_ERROR") + ":"))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-1 error_listing" },
                        [
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _c("strong", [_vm._v("Field")])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "3" } }, [
                            _c("strong", [_vm._v("Type")])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "6" } }, [
                            _c("strong", [_vm._v("Value")])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.validateUpdateErrorMessages, function(
                        message
                      ) {
                        return _c(
                          "b-row",
                          {
                            key: message.pv_id,
                            staticClass: "mb-1 error_listing"
                          },
                          [
                            _c("b-col", { attrs: { cols: "3" } }, [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")(message.key)) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "3" } }, [
                              _vm._v(
                                _vm._s(_vm._f("capitalize")(message.type)) + " "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticStyle: { "word-wrap": "break-word" },
                                attrs: { cols: "6" }
                              },
                              [_vm._v(_vm._s(message.current_value))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.optionalErrorMessages && _vm.optionalErrorMessages.length > 0
                ? _c(
                    "div",
                    { staticClass: "mb-3 error_listing" },
                    [
                      _c("h5", { staticClass: "error_listing" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("FORMS.OPTIONAL_FIELDS_VALIDATION") + ":"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.optionalErrorMessages, function(error, index) {
                        return _c(
                          "p",
                          { key: error["key"], staticClass: "error_listing" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(index + 1) +
                                ". " +
                                _vm._s(error["reason"]) +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.showSaveData }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.OKAY")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "newFieldModal",
          attrs: {
            id: "newField",
            title: _vm.$t("FORMS.ADD_FIELD"),
            "hide-header-close": "",
            centered: ""
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("label", { attrs: { for: "name" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("FORMS.LABEL")) + " ")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { id: "input1" },
                            model: {
                              value: _vm.newFieldLabel,
                              callback: function($$v) {
                                _vm.newFieldLabel = $$v
                              },
                              expression: "newFieldLabel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("label", { attrs: { for: "name" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("FORMS.VALUE")) + " ")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: { id: "input1" },
                            model: {
                              value: _vm.newFieldValue,
                              callback: function($$v) {
                                _vm.newFieldValue = $$v
                              },
                              expression: "newFieldValue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.addNewField }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.ADD")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CANCEL")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "compareCardsModal",
          staticClass: "modal-primary",
          attrs: {
            title: "Image Comparison",
            size: "lg",
            "hide-header-close": "",
            centered: "",
            "hide-footer": ""
          },
          on: { hidden: _vm.onHideCompareModal }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-1 text-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _vm.isOpenCompareUploaded
                        ? _c(
                            "b-card",
                            {
                              staticClass: "shadow",
                              attrs: { header: "Uploaded Image" }
                            },
                            [
                              _c("img", {
                                staticClass: "compare-image",
                                attrs: {
                                  oncontextmenu: "return false;",
                                  src:
                                    this.imgBase +
                                    this.formData.original_image_url
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _vm.isOpenCompareUploaded
                        ? _c(
                            "b-card",
                            {
                              staticClass: "shadow",
                              attrs: { header: "Enhanced Image" }
                            },
                            [
                              _c("img", {
                                staticClass: "compare-image",
                                attrs: {
                                  oncontextmenu: "return false;",
                                  src: this.imgBase + this.formData.image_url
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "exportErrorModal",
          attrs: {
            title: _vm.$t("FORMS.EXPORT_ERROR"),
            "hide-header-close": "",
            centered: "",
            "ok-only": "",
            "ok-variant": "secondary"
          }
        },
        [_c("p", [_vm._v(_vm._s(this.formData.short_export_error))])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addDataModal",
          attrs: { title: "Add Data Manually", size: "md" },
          on: { ok: _vm.fetchTemplateMappings }
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-input-group",
                [
                  _c("b-col", { staticClass: "p-1 col-4 col-sm-4" }, [
                    _c("label", [_vm._v("Select Template")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "p-1 col-8 col-sm-4" },
                    [
                      _c("b-form-select", {
                        staticClass: "reprocess-input",
                        attrs: {
                          plain: true,
                          options: _vm.templateOptions,
                          placeholder: _vm.$t("FORMS.TEMPLATE")
                        },
                        on: {
                          input: function($event) {
                            _vm.handleSelectedTemp()
                          }
                        },
                        model: {
                          value: _vm.selectedTemplate,
                          callback: function($$v) {
                            _vm.selectedTemplate = $$v
                          },
                          expression: "selectedTemplate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "p-1 col-12 col-sm-4" },
                    [
                      _c("zoom-center-transition", [
                        _c("img", {
                          staticClass: "shadow preview-image",
                          attrs: { src: _vm.previewImageUrl }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "p-1 col-12 col-sm-4" },
                    [
                      _c("zoom-center-transition", [
                        _c("img", {
                          staticClass: "shadow preview-image",
                          attrs: { src: _vm.pagePrevImgUrl }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "TableDataModal",
          staticClass: "modal-primary",
          attrs: {
            title: _vm.$t("FORMS.TABLE_DATA"),
            size: "lg",
            centered: "",
            "hide-footer": ""
          },
          on: { hidden: _vm.closeTableModal }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c("h4", { staticClass: "processedData" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("FORMS.PROCESSED_DATA") + ":"))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { lg: "1", offset: "9" } }, [
                    _c(
                      "div",
                      { staticClass: "save-data" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "secondary", size: "sm" },
                            on: {
                              click: function($event) {
                                _vm.saveData(true)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("COMMON.SAVE")) +
                                "\n              "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { height: "100px", width: "100%" } }, [
                _c("canvas", {
                  staticStyle: {
                    border: "1px solid",
                    width: "100%",
                    "max-height": "50px"
                  },
                  attrs: { id: "table-header-canvas" }
                }),
                _c("br"),
                _vm._v(" "),
                _c("canvas", {
                  staticStyle: {
                    border: "1px solid",
                    width: "100%",
                    "max-height": "50px"
                  },
                  attrs: { id: "table-row-canvas" }
                }),
                _c("br")
              ]),
              _vm._v(" "),
              _vm.selectedTablePath
                ? _c(
                    "b-card",
                    {
                      staticStyle: {
                        "overflow-x": "auto",
                        "margin-top": "15px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "table-model-y model-scrollbar" },
                        [
                          _c(
                            "table",
                            {
                              staticClass: "stick-table",
                              staticStyle: { "table-layout": "auto" }
                            },
                            [
                              _c(
                                "thead",
                                _vm._l(
                                  _vm.selectedTableData["children"][0][
                                    "children"
                                  ],
                                  function(header, index) {
                                    return _c("th", { key: index }, [
                                      _vm._v(_vm._s(header["key"]))
                                    ])
                                  }
                                )
                              ),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.selectedTableData["children"].slice(1),
                                  function(row, index) {
                                    return _c(
                                      "tr",
                                      {
                                        key: index,
                                        on: {
                                          mouseover: function($event) {
                                            _vm.hoverRow(row, index)
                                          }
                                        }
                                      },
                                      _vm._l(row["children"], function(
                                        cell,
                                        index
                                      ) {
                                        return _c("td", { key: index }, [
                                          cell.current_value !==
                                          cell.original_value
                                            ? _c("span", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.right",
                                                      modifiers: {
                                                        hover: true,
                                                        right: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "table-input table-input-edited",
                                                  attrs: {
                                                    title:
                                                      "Original Value: " +
                                                      cell.original_value
                                                  },
                                                  domProps: {
                                                    value: cell.current_value
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.highlightInRow(
                                                        cell,
                                                        row,
                                                        index
                                                      )
                                                    },
                                                    change: function($event) {
                                                      _vm.updateTableData(
                                                        $event,
                                                        cell
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                            : _c("span", [
                                                _c("input", {
                                                  staticClass: "table-input",
                                                  domProps: {
                                                    value: cell.current_value
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.highlightInRow(
                                                        cell,
                                                        row,
                                                        index
                                                      )
                                                    },
                                                    change: function($event) {
                                                      _vm.updateTableData(
                                                        $event,
                                                        cell
                                                      )
                                                    }
                                                  }
                                                })
                                              ])
                                        ])
                                      })
                                    )
                                  }
                                )
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "errorsAcknowledgementModal",
          attrs: {
            title: _vm.isFormDocValid
              ? _vm.$t("COMMON.CONFIRM")
              : _vm.$t("FORMS.VALIDATION_HEADER"),
            "hide-header-close": "",
            centered: "",
            "ok-variant": "secondary",
            "cancel-variant": "primary",
            "ok-title": _vm.$t("COMMON.SAVE")
          },
          on: {
            hidden: _vm.cancelExport,
            ok: _vm.exportDataToService,
            cancel: _vm.cancelExport
          }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            this.isFormDocValid
              ? _c("div", [
                  _c("div", { staticClass: "save-btn" }, [
                    _vm._v(
                      "\n            Are you sure you want to save data on Salesforce?\n          "
                    )
                  ])
                ])
              : _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "mb-1 text-center" },
                      [
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _c("strong", [_vm._v("Page No.")])
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _c("strong", [_vm._v("Errors")])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.pageLevelErrors, function(pageErrors) {
                      return _c(
                        "b-row",
                        {
                          key: pageErrors.page,
                          staticClass: "mb-1 text-center"
                        },
                        [
                          _c("b-col", { attrs: { cols: "6" } }, [
                            _vm._v(_vm._s(pageErrors.page) + " ")
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "6" } }, [
                            _vm._v(_vm._s(pageErrors.errors.length) + " ")
                          ])
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("b-row", [
                      _c("div", { staticClass: "error-acknowledgement" }, [
                        _vm._v(
                          "\n              There are data errors thats needs to be fixed. Do you really want to save data on salesforce without verifiying them?\n            "
                        )
                      ])
                    ])
                  ],
                  2
                )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "signInvoiceModal",
          attrs: {
            title: _vm.isInvoiceVerified
              ? _vm.$t("INVOICE.APPROVE_SIGN")
              : _vm.$t("INVOICE.SIGN_INVOICE"),
            "hide-header-close": "",
            centered: "",
            "ok-variant": "secondary",
            "cancel-variant": "primary",
            "ok-title": _vm.isInvoiceVerified
              ? _vm.$t("INVOICE.APPROVE")
              : _vm.$t("INVOICE.SIGN")
          },
          on: {
            hidden: _vm.hideSignInvoice,
            ok: _vm.signInvoice,
            cancel: _vm.hideSignInvoice
          }
        },
        [
          _c(
            "b-row",
            { staticClass: "m-2" },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("INVOICE.ACCOUNT"))),
                  _c("span", { staticClass: "required" }, [_vm._v("*")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c("b-form-select", {
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.invoice.selectedAccount.$error,
                      "is-valid": !_vm.$v.invoice.selectedAccount.$invalid
                    },
                    attrs: { plain: true, options: _vm.invoiceSign.accounts },
                    model: {
                      value: _vm.invoice.selectedAccount,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "selectedAccount", $$v)
                      },
                      expression: "invoice.selectedAccount"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.invoice.selectedAccount.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("INVOICE.ACC_REQ")))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "m-2" },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("INVOICE.ACCOUNTING_UNIT"))),
                  _c("span", { staticClass: "required" }, [_vm._v("*")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c("b-form-select", {
                    staticClass: "md -8 form-control",
                    class: {
                      "is-invalid":
                        _vm.$v.invoice.selectedAccountingUnit.$error,
                      "is-valid": !_vm.$v.invoice.selectedAccountingUnit
                        .$invalid
                    },
                    attrs: {
                      plain: true,
                      options: _vm.invoiceSign.accountingUnits
                    },
                    model: {
                      value: _vm.invoice.selectedAccountingUnit,
                      callback: function($$v) {
                        _vm.$set(_vm.invoice, "selectedAccountingUnit", $$v)
                      },
                      expression: "invoice.selectedAccountingUnit"
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.invoice.selectedAccountingUnit.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("INVOICE.ACC_UNIT_REQ")))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "m-2" },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("INVOICE.TOTAL_AMOUNT"))),
                  _c("span", { staticClass: "required" }, [_vm._v("*")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice.totalAmount,
                        expression: "invoice.totalAmount"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.invoice.totalAmount.$error,
                      "is-valid": !_vm.$v.invoice.totalAmount.$invalid
                    },
                    attrs: { type: "number", id: "totalAmount" },
                    domProps: { value: _vm.invoice.totalAmount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.invoice,
                          "totalAmount",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.invoice.totalAmount.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("INVOICE.AMT_REQ")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.invoice.totalAmount.minLen
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("INVOICE.MIN_AMT")))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "m-2" },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("INVOICE.NOTES")))])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "8" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.invoice.description,
                      expression: "invoice.description"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.invoice.description },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.invoice, "description", $event.target.value)
                    }
                  }
                })
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "saveFieldsAlertModel",
          attrs: {
            title: _vm.$t("COMMON.ALERT"),
            centered: "",
            "header-text-variant": "danger",
            "ok-variant": "secondary",
            "ok-title": _vm.$t("COMMON.SAVE"),
            "ok-disabled": !_vm.checkauth,
            "cancel-variant": "danger"
          },
          on: {
            ok: function($event) {
              _vm.confirmChanges()
            },
            cancel: function($event) {
              _vm.cancelNavigation(_vm.getCurrentPage)
            },
            hidden: function($event) {
              _vm.cancelNavigation(_vm.getCurrentPage)
            }
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.$t("COMMON.SAVE_ALERT")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "slaesForceAlertModal",
          attrs: {
            centered: "",
            title: "Sales Force Validation Error",
            "ok-variant": "secondary",
            "ok-only": ""
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.salesForeceValidationError) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "multipleUserAlert",
          attrs: {
            title: _vm.$t("FORMS.MULTI_USER_MODAL"),
            "hide-header-close": "",
            centered: ""
          }
        },
        [
          _c("strong", [_vm._v(_vm._s(_vm.$t("FORMS.MULTI_USER_ALERT_MSG")))]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "secondary" },
                  on: { click: _vm.goBackToFormsPage }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.GO_BACK")) + " ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "rejectFormDoc",
          attrs: {
            "hide-header-close": "",
            title: "Reject Form",
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            { staticClass: "mt-3" },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../static/img/exclamation.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Do you want to reject this document?")])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: { click: _vm.rejectForm }
                },
                [_vm._v(" Confirm ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hideRejectFormDocModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CANCEL")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b81e9c6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81e9c6e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forms/processForm.vue
// module id = 1177
// module chunks = 2